import { IEditorCommandTypeLite } from '@commandbar/internal/middleware/types';

export const getColorsFromCommands = (commands: IEditorCommandTypeLite[]) => {
  return commands
    .filter((command) => command.icon && command.icon.includes('#'))
    .map((command) => (command.icon ? `#${command.icon.split('#')[1]}` : ''));
};
